/* ==========================================================
   כלל "מוצר בסיס חובה" – תוספות לא נשארות/נרכשות לבד
   ----------------------------------------------------------
   דרישה: לעולם לא תיווצר עגלה – ולא יתאפשר תשלום – שמכילה
   רק תוספות (האפסל/המנוי ו/או ביטוח המשלוח) בלי מוצר בסיס
   אמיתי מהחנות.

   שתי שכבות הגנה:

   1. ניקוי עגלה – בכל שינוי/טעינה: אם אין בעגלה מוצר בסיס,
      כל פריטי התוספת מוסרים יחד והעגלה מתרוקנת.

   2. חסימת כפתור התשלום – מכיוון שלניקוי יש דיליי קצר,
      לחיצה על "תשלום מאובטח" נעצרת ונבדקת מול העגלה בזמן
      אמת: אם אין מוצר בסיס, המעבר לצ'קאאוט נחסם והתוספות
      מנוקות. כך נסגר גם המצב של לחיצה מהירה בתוך חלון הדיליי.

   זיהוי המוצרים:
   - ADDON_PRODUCT_IDS – מוצרים שאינם "מוצר בסיס" (האפסל +
     ביטוח המשלוח). "מוצר בסיס" = כל פריט בעגלה שאינו ברשימה.
   - מזהי אפסל נלמדים גם אוטומטית מכרטיסי אפסל שמופיעים
     בעמוד/במגירה ונשמרים ב-localStorage.

   הקובץ נטען בכל עמוד דרך snippets/cart-drawer-script.liquid.
   ========================================================== */
(function () {
  // מוצרי תוספת: מנוי חודשי SOURCE + ביטוח משלוח ועדיפות אריזה
  var ADDON_PRODUCT_IDS = [7687848656993, 7657254518881];
  var STORE_KEY = 'nativa_upsell_product_ids';
  var CHECKOUT_SELECTOR = '#CartDrawer-Checkout, button[name="checkout"], .cart__checkout-button';

  function learned() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function remember(ids) {
    try {
      var set = {};
      learned().concat(ids).forEach(function (id) { if (id) set[Number(id)] = 1; });
      localStorage.setItem(STORE_KEY, JSON.stringify(Object.keys(set).map(Number)));
    } catch (e) {}
  }

  /* קבוצת התוספות = הרשימה הקבועה + מזהי אפסל שנלמדו */
  function addonSet() {
    var set = {};
    ADDON_PRODUCT_IDS.concat(learned()).forEach(function (id) { set[Number(id)] = 1; });
    return set;
  }

  function cartHasBase(cart) {
    var addons = addonSet();
    return (cart.items || []).some(function (i) { return !addons[Number(i.product_id)]; });
  }

  /* לימוד מזהי אפסל מכל כרטיס אפסל שמופיע (עמוד הבית / מגירה) */
  function learnFromDom() {
    var found = [];
    document.querySelectorAll('[id^="ProductJson-"]').forEach(function (el) {
      if (!el.closest('.upsell-form')) return; // רק כרטיסי אפסל
      try {
        var p = JSON.parse(el.textContent);
        if (p && p.id) found.push(Number(p.id));
      } catch (e) {}
    });
    if (found.length) remember(found);
  }

  /* ---- שכבה 1: ניקוי העגלה מתוספות שנשארו לבד ---- */
  var busy = false;
  function enforce() {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) return null;
        if (cartHasBase(cart)) return null; // יש מוצר בסיס – תקין

        var addons = addonSet();
        var updates = {};
        var removing = false;
        items.forEach(function (i) {
          if (addons[Number(i.product_id)]) { updates[i.key] = 0; removing = true; }
        });
        if (!removing) return null;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (typeof window.refreshCartDrawer === 'function') { return window.refreshCartDrawer(); }
          });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function run() { learnFromDom(); return enforce(); }

  /* ---- שכבה 2: חסימת מעבר לצ'קאאוט ללא מוצר בסיס ----
     כל לחיצה על כפתור התשלום נעצרת, נבדקת מול העגלה בזמן
     אמת, וממשיכה רק אם יש מוצר בסיס. כך הדיליי של שכבה 1
     כבר לא רלוונטי – ההחלטה נעשית על סמך העגלה העדכנית. */
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest(CHECKOUT_SELECTOR)
      : null;
    if (!button) return;
    if (button.dataset.baseGuardPass === '1') return; // מעבר מאושר – לא לחסום

    event.preventDefault();
    event.stopImmediatePropagation();

    button.classList.add('is-loading');

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        button.classList.remove('is-loading');

        if (cartHasBase(cart)) {
          // יש מוצר בסיס – ממשיכים לצ'קאאוט
          button.dataset.baseGuardPass = '1';
          button.click();
          setTimeout(function () { delete button.dataset.baseGuardPass; }, 3000);
        } else {
          // אין מוצר בסיס – חוסמים ומנקים את התוספות
          enforce();
        }
      })
      .catch(function () {
        // אם הבדיקה נכשלה, לא חוסמים לקוח לגיטימי
        button.classList.remove('is-loading');
        button.dataset.baseGuardPass = '1';
        button.click();
        setTimeout(function () { delete button.dataset.baseGuardPass; }, 3000);
      });
  }, true);

  /* ---- מתי מריצים את הניקוי ---- */
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, run);
  }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('pageshow', run);
  run();
})();